import { render, staticRenderFns } from "./causeSetting.vue?vue&type=template&id=61b6ac6c&scoped=true&"
import script from "./causeSetting.vue?vue&type=script&lang=js&"
export * from "./causeSetting.vue?vue&type=script&lang=js&"
import style0 from "./causeSetting.vue?vue&type=style&index=0&id=61b6ac6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6ac6c",
  null
  
)

export default component.exports